import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class WorkDone extends Field {
  static subqueriesForModel() {
    return { workDone: ['text'] };
  }

  get title() {
    return 'Work done';
  }

  exampleContents(): FieldContentsData {
    return { text: '1d', icon: { name: 'fa-regular fa-clock' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.workDone?.text) {
      return {
        text: record.workDone.text,
        icon: { name: 'fa-regular fa-clock' },
      };
    }

    return {};
  }
}
